import React from 'react';
import { X, Home, Search, Bell, MessageSquare, User, LogOut, Shield, Flame, Zap, Activity, Target } from 'lucide-react';

const MobileMenu = ({ 
  mobileMenuOpen, 
  setMobileMenuOpen, 
  darkMode, 
  setDarkMode, 
  activeTab, 
  handleTabChange, 
  unreadNotifications, 
  unreadDMs, 
  currentUser, 
  handleUserSelection, 
  handleLogout,
  hasPendingRankUp = false,
  onRankUpClick
}) => {
  if (!mobileMenuOpen) return null;

  return (
    <div className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-50" onClick={() => setMobileMenuOpen(false)}>
      <div className="w-64 h-full bg-black border-r border-gray-800" onClick={(e) => e.stopPropagation()}>
        <div className="p-4">
          <div className="flex items-center justify-between mb-6">
            <img 
              src="/newlogo.gif" 
              alt="TopBlast" 
              className="h-24 w-auto"
            />
            <button
              onClick={() => setMobileMenuOpen(false)}
              className="text-gray-500 hover:text-white"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
          
          
          {/* Navigation */}
          <nav className="space-y-2">
            <button
              onClick={() => {
                handleTabChange('home');
                setMobileMenuOpen(false);
              }}
              className={`flex items-center space-x-3 p-3 rounded-full hover:bg-gray-900 transition-colors w-full text-left ${
                activeTab === 'home' ? 'font-bold' : ''
              }`}
            >
              <Home className="w-6 h-6 text-white" />
              <span>Home</span>
            </button>
            <button
              onClick={() => {
                handleTabChange('big-movers');
                setMobileMenuOpen(false);
              }}
              className={`flex items-center space-x-3 p-3 rounded-full hover:bg-gray-900 transition-colors w-full text-left ${
                activeTab === 'big-movers' ? 'font-bold' : ''
              }`}
            >
              <Flame className="w-6 h-6 text-red-500" />
              <span className={activeTab === 'big-movers' ? 'text-red-400' : ''}>
                Big Movers
              </span>
            </button>
            <button
              onClick={() => {
                handleTabChange('xp-dashboard');
                setMobileMenuOpen(false);
              }}
              className={`flex items-center space-x-3 p-3 rounded-full hover:bg-gray-900 transition-colors w-full text-left ${
                activeTab === 'xp-dashboard' ? 'font-bold' : ''
              }`}
            >
              <Activity className="w-6 h-6 text-yellow-500" />
              <span className={activeTab === 'xp-dashboard' ? 'text-yellow-400' : ''}>
                Analytics
              </span>
            </button>
            <button
              onClick={() => {
                if (hasPendingRankUp && onRankUpClick) {
                  onRankUpClick();
                }
                handleTabChange('level-up');
                setMobileMenuOpen(false);
              }}
              className={`relative flex items-center space-x-3 p-3 rounded-full hover:bg-gray-900 transition-colors w-full text-left ${
                activeTab === 'level-up' ? 'font-bold text-purple-400' : ''
              } ${
                hasPendingRankUp ? 'level-up-pending level-up-pulse' : ''
              }`}
            >
              <div className={`relative ${hasPendingRankUp ? 'level-up-bounce' : ''}`}>
                <Zap className={`w-6 h-6 ${hasPendingRankUp ? 'level-up-glow text-purple-400' : 'text-purple-500'}`} />
                {hasPendingRankUp && (
                  <div className="absolute -top-1 -right-1 w-3 h-3 bg-pink-500 rounded-full animate-ping"></div>
                )}
              </div>
              <span className={hasPendingRankUp ? 'level-up-glow font-bold' : ''}>
                Rank Up{hasPendingRankUp ? ' 🎉' : ''}
              </span>
              {hasPendingRankUp && (
                <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                  <div className="w-2 h-2 bg-pink-500 rounded-full animate-pulse"></div>
                </div>
              )}
            </button>
            <button
              onClick={() => {
                handleTabChange('explore');
                setMobileMenuOpen(false);
              }}
              className={`flex items-center space-x-3 p-3 rounded-full hover:bg-gray-900 transition-colors w-full text-left ${
                activeTab === 'explore' ? 'font-bold' : ''
              }`}
            >
              <Search className="w-6 h-6 text-blue-500" />
              <span className={activeTab === 'explore' ? 'text-blue-400' : ''}>Explore</span>
            </button>
            <button
              onClick={() => {
                handleTabChange('notifications');
                setMobileMenuOpen(false);
              }}
              className={`flex items-center space-x-3 p-3 rounded-full hover:bg-gray-900 transition-colors w-full text-left relative ${
                activeTab === 'notifications' ? 'font-bold' : ''
              }`}
            >
              <Bell className="w-6 h-6 text-orange-500" />
              <span className={activeTab === 'notifications' ? 'text-orange-400' : ''}>Notifications</span>
              {unreadNotifications > 0 && (
                <span className="absolute right-3 top-1/2 -translate-y-1/2 bg-gradient-to-r from-pink-500 to-purple-600 text-white text-xs rounded-full min-w-[20px] h-5 px-1 flex items-center justify-center">
                  {unreadNotifications > 99 ? '99+' : unreadNotifications}
                </span>
              )}
            </button>
            <button
              onClick={() => {
                handleTabChange('messages');
                setMobileMenuOpen(false);
              }}
              className={`flex items-center space-x-3 p-3 rounded-full hover:bg-gray-900 transition-colors w-full text-left relative ${
                activeTab === 'messages' ? 'font-bold' : ''
              }`}
            >
              <MessageSquare className="w-6 h-6 text-cyan-500" />
              <span className={activeTab === 'messages' ? 'text-cyan-400' : ''}>Messages</span>
              {unreadDMs > 0 && (
                <span className="absolute right-3 top-1/2 -translate-y-1/2 bg-gradient-to-r from-pink-500 to-purple-600 text-white text-xs rounded-full min-w-[20px] h-5 px-1 flex items-center justify-center">
                  {unreadDMs > 99 ? '99+' : unreadDMs}
                </span>
              )}
            </button>
            <button
              onClick={() => {
                handleUserSelection(currentUser);
                handleTabChange('profile');
                setMobileMenuOpen(false);
              }}
              className={`flex items-center space-x-3 p-3 rounded-full hover:bg-gray-900 transition-colors w-full text-left ${
                activeTab === 'profile' ? 'font-bold' : ''
              }`}
            >
              <User className="w-6 h-6 text-green-500" />
              <span className={activeTab === 'profile' ? 'text-green-400' : ''}>Profile</span>
            </button>
            <button
              onClick={() => {
                handleTabChange('tokenomics');
                setMobileMenuOpen(false);
              }}
              className={`flex items-center space-x-3 p-3 rounded-full hover:bg-gray-900 transition-colors w-full text-left ${
                activeTab === 'tokenomics' ? 'font-bold' : ''
              }`}
            >
              <Target className="w-6 h-6 text-purple-500" />
              <span className={activeTab === 'tokenomics' ? 'text-purple-400' : ''}>Tokenomics</span>
            </button>
            <button
              onClick={() => {
                handleTabChange('terms');
                setMobileMenuOpen(false);
              }}
              className={`flex items-center space-x-3 p-3 rounded-full hover:bg-gray-900 transition-colors w-full text-left ${
                activeTab === 'terms' ? 'font-bold' : ''
              }`}
            >
              <Shield className="w-6 h-6 text-gray-500" />
              <span className={activeTab === 'terms' ? 'text-gray-400' : ''}>Terms</span>
            </button>
          </nav>
          
          {/* User Profile Section */}
          <div className="mt-auto pt-6 border-t border-gray-800">
            <div 
              className="flex items-center space-x-3 p-2"
              onClick={() => {
                handleUserSelection(currentUser);
                handleTabChange('profile');
                setMobileMenuOpen(false);
              }}
            >
              <img 
                src={currentUser?.avatar || `https://api.dicebear.com/7.x/avataaars/svg?seed=${currentUser?.username || 'default'}`} 
                alt={currentUser?.username || 'User'} 
                className="w-10 h-10 rounded-full"
              />
              <div className="flex-1">
                <p className="text-white font-medium">{currentUser?.username || 'Loading...'}</p>
                <p className="text-gray-500 text-sm">{currentUser?.handle || '@loading'}</p>
              </div>
            </div>
            <button
              onClick={handleLogout}
              className="w-full mt-4 p-3 text-red-500 hover:bg-red-950/20 rounded-lg transition-colors flex items-center justify-center space-x-2"
            >
              <LogOut className="w-5 h-5" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;